import axios from "axios";

const clientAxios = axios.create({
  baseURL: "https://apitasksandflows.herokuapp.com/", //process.env.REACT_APP_BACKEND_API,
});

export default clientAxios;
